import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
//import reportWebVitals from './reportWebVitals';
import { initializeCsrf } from "./services/api";
//import "altcha";

const root = ReactDOM.createRoot(document.getElementById("root"));

const renderApp = () => {
  root.render(<App />);
};

initializeCsrf()
  .catch(() => {})
  .finally(renderApp);

//reportWebVitals();
